import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, ArrowUpRight } from 'lucide-react';
import axios from 'axios';
import { API } from '../App';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [settings, setSettings] = useState({
    phone: '08 6187 5523',
    email: 'info.eca@extreme-clean.com.au',
    address: '18/92-94 Poole St, Welshpool WA 6106',
    hours_weekday: '8:00 AM - 5:00 PM',
    hours_weekend: 'Closed'
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API}/settings`);
        if (res.data) {
          setSettings(res.data);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="bg-[#273268] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_customer-portal-v2/artifacts/kd8dey33_logo_final-1_1_page-0001.jpeg" 
                alt="Extreme Clean Australia" 
                className="h-16 w-auto bg-white p-2 rounded"
              />
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-6">
              Professional cleaning services across Western Australia. 
              {new Date().getFullYear() - 2006}+ years of excellence in commercial cleaning.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.linkedin.com/in/extreme-clean-australia-419b0327" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 border border-neutral-700 flex items-center justify-center hover:border-white hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              <a 
                href="https://www.instagram.com/extremecleanaustralia" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 border border-neutral-700 flex items-center justify-center hover:border-white hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
              <a 
                href="https://www.facebook.com/share/1FcTtfxCQK/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 border border-neutral-700 flex items-center justify-center hover:border-white hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Services', 'About', 'FAQ', 'Contact', 'Clients'].map((link) => (
                <li key={link}>
                  <Link 
                    to={link === 'Home' ? '/' : `/${link.toLowerCase()}`}
                    className="text-neutral-400 hover:text-white transition-colors text-sm flex items-center gap-2 group"
                  >
                    <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6 uppercase tracking-wider">Services</h4>
            <ul className="space-y-3">
              {[
                { name: 'Commercial Kitchen', path: '/services/commercial-kitchen-cleaning-perth' },
                { name: 'Canopy & Exhaust', path: '/services/canopy-duct-fan-cleaning-perth' },
                { name: 'Warehouse & Industrial', path: '/services/warehouse-industrial-cleaning-perth' },
                { name: 'Office Cleaning', path: '/services/commercial-office-cleaning-perth' },
                { name: 'Window Cleaning', path: '/services/commercial-window-cleaning-perth' },
                { name: 'Carpet Cleaning', path: '/services/commercial-carpet-cleaning-perth' },
                { name: 'High-Pressure Cleaning', path: '/services/commercial-high-pressure-cleaning-perth' },
                { name: 'Pizza Oven Cleaning', path: '/services/commercial-pizza-oven-cleaning-perth' }
              ].map((service) => (
                <li key={service.name}>
                  <Link 
                    to={service.path}
                    className="text-neutral-400 hover:text-white transition-colors text-sm flex items-center gap-2 group"
                  >
                    <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6 uppercase tracking-wider">Industries</h4>
            <ul className="space-y-3">
              {[
                { name: 'Schools & Education', path: '/industries/schools-educational-facilities-perth' },
                { name: 'Government Buildings', path: '/industries/government-building-cleaning-perth' },
                { name: 'Aged Care & Healthcare', path: '/industries/aged-care-healthcare-cleaning-perth' },
                { name: 'Strata & Apartments', path: '/industries/strata-apartment-cleaning-perth' }
              ].map((industry) => (
                <li key={industry.name}>
                  <Link 
                    to={industry.path}
                    className="text-neutral-400 hover:text-white transition-colors text-sm flex items-center gap-2 group"
                  >
                    <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                    {industry.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6 uppercase tracking-wider">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#3B82F6] mt-0.5" />
                <div>
                  <a href="tel:0861875523" className="text-sm font-mono hover:text-[#3B82F6] transition-colors">08 6187 5523</a>
                  <p className="text-neutral-400 text-xs">Call Us</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#3B82F6] mt-0.5" />
                <div>
                  <a href={`mailto:${settings.email}`} className="text-sm hover:text-[#3B82F6] transition-colors">{settings.email}</a>
                  <p className="text-neutral-400 text-xs">Email Us</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={18} className="text-[#3B82F6] mt-0.5" />
                <div>
                  <p className="text-sm">Mon - Fri: {settings.hours_weekday}</p>
                  <p className="text-sm text-neutral-400">Sat & Sun: {settings.hours_weekend}</p>
                  <p className="text-neutral-400 text-xs mt-1">Cleaning 24/7 by arrangement</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#3B82F6] mt-0.5" />
                <div>
                  <p className="text-sm">Entire Western Australia</p>
                  <p className="text-neutral-400 text-xs">Service Area</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-neutral-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            © {currentYear} Extreme Clean Australia. All rights reserved.
          </p>
          <div className="flex gap-6 items-center">
            <a 
              href="https://maps.app.goo.gl/6UidyLJhWLaTNiyH6" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-neutral-500 hover:text-white text-sm transition-colors"
              data-testid="footer-google-link"
            >
              Find us on Google
            </a>
            <Link to="/privacy-policy" className="text-neutral-500 hover:text-white text-sm transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-neutral-500 hover:text-white text-sm transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
